import { CanceledError } from 'axios';

export class TenantSessionChangedError extends CanceledError<unknown> {}

export function isTenantSessionCurrent(expectedJwt: string | null, memoryJwt: string | null, storedJwt: string | null): boolean {
  return expectedJwt === memoryJwt && expectedJwt === storedJwt;
}

export function requireTenantSession(expectedJwt: string | null, memoryJwt: string | null, storedJwt: string | null, replace: (url: string) => void): void {
  if (isTenantSessionCurrent(expectedJwt, memoryJwt, storedJwt)) return;
  replace(storedJwt ? '/dashboard' : '/login');
  throw new TenantSessionChangedError('Tenant session changed');
}

export function readStoredTenantJwt(): string | null {
  try { return localStorage.getItem('tenant_jwt'); } catch { return null; }
}

export function requireCurrentTenantSession(expectedJwt: string | null, memoryJwt: string | null): void {
  requireTenantSession(expectedJwt, memoryJwt, readStoredTenantJwt(), path => window.location.replace(path));
}
